/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2020-03-13 11:10:15
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { Icon } from '@shopify/polaris';
import { ArrowUpMinor, ArrowDownMinor } from '@shopify/polaris-icons';

import { formatNumberInThousand, formatNumberWithMoney } from 'src/helpers';

type Props = {
  compare: boolean,
  total: number,
  percentChange: number
};
// DONE
class Total extends Component<Props> {
  render() {
    const { compare, total, percentChange, isMoneyFormat = false } = this.props;

    const renderPercentChange = {
      empty: <span className="percentChange">-</span>,
      up: (
        <span className="percentChange up">
          <span style={{ display: 'flex' }}>
            <Icon source={ArrowUpMinor} color="success" />
            {formatNumberInThousand(percentChange)}%
          </span>
        </span>
      ),
      down: (
        <span className="percentChange down">
          <span style={{ display: 'flex' }}>
            <Icon source={ArrowDownMinor} color="critical" />
            {formatNumberInThousand(Math.abs(percentChange))}%
          </span>
        </span>
      ),
      unchanged: <span className="percentChange">{percentChange}%</span>
    };

    const status =
      !compare || percentChange === null
        ? 'empty'
        : percentChange > 0
        ? 'up'
        : percentChange < 0
        ? 'down'
        : 'unchanged';

    return (
      <div className="summary">
        <span
          className="total"
          dangerouslySetInnerHTML={{
            __html: isMoneyFormat
              ? formatNumberWithMoney(formatNumberInThousand(total))
              : formatNumberInThousand(total)
          }}></span>
        {compare ? renderPercentChange[status] : ''}
      </div>
    );
  }
}

export default Total;
